import { Component, input, computed, output } from '@angular/core';
import { getCategoryLabel } from '../../enums/category.enum';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-map-popup',
    imports: [TranslateModule],
    templateUrl: './map-popup.component.html',
    styleUrl: './map-popup.component.css'
})
export class MapPopupComponent {
    denominacion = input.required<string>();
    categoria = input.required<string>();
    OBJECTID = input.required<number>();
    image = input.required<string>();

    navigate = output<void>();

    categoriaLabel = computed(() => getCategoryLabel(this.categoria()));

    onNavigate(event: MouseEvent) {
        event.stopPropagation();
        this.navigate.emit();
    }
}
